import { render, staticRenderFns } from "./TunnelConfigurationList.vue?vue&type=template&id=2cbbbc8e&"
import script from "./TunnelConfigurationList.vue?vue&type=script&lang=js&"
export * from "./TunnelConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports